import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { OrderDetailedService } from 'src/app/shared/services/order-details.service';
import { FlowManagementService } from './services/flow-management.service';
import { RevocationTerminationService } from './services/revocation-termination.service';
import { QRCodeModule } from 'angularx-qrcode';
import { ConfigLoaderService } from './services/config-loader.service';
import { UtilsService } from './services/utils.service';
import { NavigationModule } from '@vfde-fe/ngx-lib/components/navigation';
import { NotificationModule } from '@vfde-fe/ngx-lib/components/new-notification';
import { AnchorLinkModule } from '@vfde-fe/ngx-lib/components/new-anchor-link';
import { CheckListMultiLineModule } from '@vfde-fe/ngx-lib/components/check-list-multiline';
import { PhoneNumberPipeModule } from '@vfde-fe/ngx-lib/pipes/phone-number';
import { ItemCardModule } from '@vfde-fe/ngx-lib/components/item-card';
import { SpinnerModule } from '@vfde-fe/ngx-lib/components/spinner';
import { AccordionGroupModule } from '@vfde-fe/ngx-lib/components/accordion-group';
import { StepperModule } from '@vfde-fe/ngx-lib/components/stepper-module';
import { AccordionModule } from '@vfde-fe/ngx-lib/components/accordion';
import { RadioTilesModule } from '@vfde-fe/ngx-lib/components/radio-tiles';
import { DatepickerModule } from '@vfde-fe/ngx-lib/components/date-picker';
import { TextModule } from '@vfde-fe/ngx-lib/components/new-text';
import { TrackingIconModule } from '@vfde-fe/ngx-lib/components/tracking-icon';
import { DropDownStandAloneModule } from '@vfde-fe/ngx-lib/components/dropdown-stand-alone';
import { MultiRouteStepperModule } from '@vfde-fe/ngx-lib/components/multi-route-stepper';
import { OneStepStepperModule  } from '@vfde-fe/ngx-lib/components/one-step-stepper';
import { DeviceSelectorModule } from '@vfde-fe/ngx-lib/components/device-selector';
import { InstructionCardModule } from '@vfde-fe/ngx-lib/components/instruction-card';
import { TeaserModule } from '@vfde-fe/ngx-lib/components/teaser';
import { TrimPipeModule } from '@vfde-fe/ngx-lib/pipes/trim';
import { FilterDropDownsModule } from '@vfde-fe/ngx-lib/components/filter-dropdowns';
import { DeviceOverviewModule } from '@vfde-fe/ngx-lib/components/device-overview';
import { PriceModule } from '@vfde-fe/ngx-lib/pipes/price';
import { OrderByPipeModule } from '@vfde-fe/ngx-lib/pipes/order-by';
import { HtmlTemplateModule } from '@vfde-fe/ngx-lib/components/html-template';
import { FallbackTranslatePipeModule } from '@vfde-fe/ngx-lib/pipes/fallback-translate';
import { TransactionHeaderLightModule } from '@vfde-fe/ngx-lib/components/transaction-header-light';
import { DetectDataLossService } from '@vfde-fe/ngx-lib/services/detect-data-loss';
import { UserService } from '@vfde-fe/ngx-lib/services/user';
import { StringConverterPipeModule } from '@vfde-fe/ngx-lib/pipes/string-converter';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { EffectsModule } from '@ngrx/effects';
import { OrderDetailsEffects } from '../redux/effects/order-details.effects';
import { SimNumberPipe } from './pipes/sim-number-pipe/sim-number.pipe';
import { IMEINumberPipe } from './pipes/imei-number-pipe/imei-number.pipe';

/** SharedModule */
@NgModule({
    imports: [
        EffectsModule.forFeature([OrderDetailsEffects]),
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        TranslateModule.forChild(),
        NavigationModule,
        NotificationModule,
        QRCodeModule,
        TransactionHeaderLightModule,
        AnchorLinkModule,
        CheckListMultiLineModule,
        PhoneNumberPipeModule,
        ItemCardModule,
        SpinnerModule,
        AccordionGroupModule,
        StepperModule,
        AccordionModule,
        RadioTilesModule,
        DatepickerModule,
        TextModule,
        TrackingIconModule,
        DropDownStandAloneModule,
        MultiRouteStepperModule,
        OneStepStepperModule,
        DeviceSelectorModule,
        InstructionCardModule,
        TeaserModule,
        TrimPipeModule,
        FilterDropDownsModule,
        DeviceOverviewModule,
        PriceModule,
        OrderByPipeModule,
        HtmlTemplateModule,
        FallbackTranslatePipeModule,
        StringConverterPipeModule,
        NgxSmartModalModule.forRoot(),
        RouterModule,
        SimNumberPipe,
        IMEINumberPipe,
    ],
    declarations: [],
    exports: [
        EffectsModule,
        TranslateModule,
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        QRCodeModule,
        NavigationModule,
        NotificationModule,
        TransactionHeaderLightModule,
        AnchorLinkModule,
        CheckListMultiLineModule,
        PhoneNumberPipeModule,
        ItemCardModule,
        SpinnerModule,
        AccordionGroupModule,
        StepperModule,
        AccordionModule,
        RadioTilesModule,
        DatepickerModule,
        TextModule,
        TrackingIconModule,
        DropDownStandAloneModule,
        MultiRouteStepperModule,
        OneStepStepperModule,
        DeviceSelectorModule,
        InstructionCardModule,
        TeaserModule,
        TrimPipeModule,
        FilterDropDownsModule,
        DeviceOverviewModule,
        PriceModule,
        OrderByPipeModule,
        HtmlTemplateModule,
        FallbackTranslatePipeModule,
        StringConverterPipeModule,
        NgxSmartModalModule,
        RouterModule,
        SimNumberPipe,
        IMEINumberPipe,
    ],
})
/** SharedModule */
export class SharedModule {
/** forRoot */
    public static forRoot (): ModuleWithProviders<any> {
        return {
            ngModule: SharedModule,
            providers: [
                OrderDetailedService,
                FlowManagementService,
                ConfigLoaderService,
                RevocationTerminationService,
                UtilsService,
                DetectDataLossService,
                UserService,
                SimNumberPipe,
                IMEINumberPipe,
            ],
        };
    }
}
